import dayjs from 'dayjs';
import React from 'react';
import './AppFooter.scss';


interface AppFooterProps { }

const AppFooter: React.FC<AppFooterProps> = () => {

  return (
    <div id="footer" className="flex_jcenter">
      <p>&copy; {dayjs().get('year')} by Keys To Success, a Ken Garff for Good Program</p>
    </div>
  );
};

export default AppFooter;
